import React from 'react';
import PropTypes from 'prop-types';

import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import SkillIcon from 'material-ui/svg-icons/social/public';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import ActivityIcon from 'material-ui/svg-icons/action/timeline';
import ComplianceIcon from 'material-ui/svg-icons/action/done-all';

import UserSkillList from '../User/UserSkillList';

const getMenuItems = () => [
    {
        link: '/dashboard/mytraining',
        icon: <SchoolIcon />,
        label: 'My training',
    },
    {
        link: '/dashboard/mytraining/compliance',
        icon: <ComplianceIcon />,
        label: 'My compliance',
    },
    {
        link: '/dashboard/mytraining/skills',
        icon: <SkillIcon />,
        label: 'My skills',
    },
    {
        link: '/dashboard/mytraining/courses',
        icon: <SchoolIcon />,
        label: 'My courses',
    },
    {
        link: '/dashboard/mytraining/modules',
        icon: <SchoolIcon />,
        label: 'My modules',
    },
    {
        link: '/dashboard/mytraining/resources',
        icon: <LibraryIcon />,
        label: 'My resources',
    },
    {
        link: '/dashboard/mytraining/activities',
        icon: <ActivityIcon />,
        label: 'My Activities',
    },
    {
        type:'divider'
    },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

const MySkillList = (props, {auth}) => <UserSkillList userId={auth.identity.id} actions={getMenuItems()}/>;

MySkillList.contextTypes = {
    auth : PropTypes.object.isRequired
};

MySkillList.defaultProps = {
    sortOptions: [
        {label: 'Name', value: 'name'},
        {label: 'Valid from', value: 'validFrom'},
        {label: 'Code', value: 'code'},
        {label: 'Level', value: 'level'}
    ]
};

export default MySkillList;
